import type { ThemeCollection } from '../types/theme.types';

// Original 7 themes with refined elliptical shapes - blur values converted to percentages
export const BASE_THEMES: ThemeCollection = {
  sunset: {
    backgroundColor: '#1a1a2e',
    shapes: [
      {
        id: 'sunset-1',
        width: 70,
        height: 35,
        x: -15,
        y: -5,
        gradient: 'radial-gradient(ellipse, #ff6b6b 0%, #ee5a24 50%, #ff9ff3 100%)',
        blur: 15,
        opacity: 0.7,
        zIndex: 1,
      },
      {
        id: 'sunset-2',
        width: 80,
        height: 30,
        x: 40,
        y: 25,
        gradient: 'radial-gradient(ellipse, #feca57 0%, #ff9ff3 50%, #ff6b6b 100%)',
        blur: 20,
        opacity: 0.6,
        zIndex: 2,
      },
      {
        id: 'sunset-3',
        width: 60,
        height: 25,
        x: 10,
        y: 60,
        gradient: 'radial-gradient(ellipse, #ff9ff3 0%, #a55eea 50%, #26de81 100%)',
        blur: 18,
        opacity: 0.5,
        zIndex: 3,
      },
    ],
  },
  ocean: {
    backgroundColor: '#0c1821',
    shapes: [
      {
        id: 'ocean-1',
        width: 75,
        height: 30,
        x: -10,
        y: 15,
        gradient: 'radial-gradient(ellipse, #00d2d3 0%, #54a0ff 50%, #5f27cd 100%)',
        blur: 19,
        opacity: 0.8,
        zIndex: 1,
      },
      {
        id: 'ocean-2',
        width: 65,
        height: 25,
        x: 50,
        y: -5,
        gradient: 'radial-gradient(ellipse, #0abde3 0%, #006ba6 50%, #00d2d3 100%)',
        blur: 16,
        opacity: 0.6,
        zIndex: 2,
      },
      {
        id: 'ocean-3',
        width: 70,
        height: 28,
        x: 20,
        y: 65,
        gradient: 'radial-gradient(ellipse, #74b9ff 0%, #0984e3 50%, #00cec9 100%)',
        blur: 21,
        opacity: 0.7,
        zIndex: 3,
      },
    ],
  },
  aurora: {
    backgroundColor: '#1a1a2e',
    shapes: [
      {
        id: 'aurora-1',
        width: 85,
        height: 25,
        x: 5,
        y: -5,
        gradient: 'radial-gradient(ellipse, #a55eea 0%, #26de81 50%, #fd79a8 100%)',
        blur: 23,
        opacity: 0.6,
        zIndex: 1,
      },
      {
        id: 'aurora-2',
        width: 65,
        height: 30,
        x: -20,
        y: 45,
        gradient: 'radial-gradient(ellipse, #00cec9 0%, #74b9ff 50%, #a29bfe 100%)',
        blur: 18,
        opacity: 0.8,
        zIndex: 2,
      },
      {
        id: 'aurora-3',
        width: 70,
        height: 25,
        x: 60,
        y: 35,
        gradient: 'radial-gradient(ellipse, #fd79a8 0%, #e84393 50%, #00b894 100%)',
        blur: 20,
        opacity: 0.5,
        zIndex: 3,
      },
      {
        id: 'aurora-4',
        width: 55,
        height: 20,
        x: 40,
        y: 75,
        gradient: 'radial-gradient(ellipse, #6c5ce7 0%, #a29bfe 50%, #fd79a8 100%)',
        blur: 15,
        opacity: 0.7,
        zIndex: 4,
      },
    ],
  },
  cosmic: {
    backgroundColor: '#0f0f23',
    shapes: [
      {
        id: 'cosmic-1',
        width: 90,
        height: 30,
        x: -20,
        y: 20,
        gradient: 'radial-gradient(ellipse, #6c5ce7 0%, #a55eea 50%, #fd79a8 100%)',
        blur: 25,
        opacity: 0.7,
        zIndex: 1,
      },
      {
        id: 'cosmic-2',
        width: 75,
        height: 25,
        x: 45,
        y: -5,
        gradient: 'radial-gradient(ellipse, #e17055 0%, #d63031 50%, #74b9ff 100%)',
        blur: 21,
        opacity: 0.6,
        zIndex: 2,
      },
      {
        id: 'cosmic-3',
        width: 80,
        height: 28,
        x: 15,
        y: 60,
        gradient: 'radial-gradient(ellipse, #fd79a8 0%, #fdcb6e 50%, #6c5ce7 100%)',
        blur: 19,
        opacity: 0.8,
        zIndex: 3,
      },
    ],
  },
  forest: {
    backgroundColor: '#1e3c1e',
    shapes: [
      {
        id: 'forest-1',
        width: 85,
        height: 25,
        x: -15,
        y: 25,
        gradient: 'radial-gradient(ellipse, #00b894 0%, #00cec9 50%, #fdcb6e 100%)',
        blur: 18,
        opacity: 0.7,
        zIndex: 1,
      },
      {
        id: 'forest-2',
        width: 70,
        height: 30,
        x: 50,
        y: -5,
        gradient: 'radial-gradient(ellipse, #26de81 0%, #6c5ce7 50%, #00b894 100%)',
        blur: 20,
        opacity: 0.6,
        zIndex: 2,
      },
      {
        id: 'forest-3',
        width: 65,
        height: 25,
        x: 20,
        y: 60,
        gradient: 'radial-gradient(ellipse, #fdcb6e 0%, #e17055 50%, #00cec9 100%)',
        blur: 16,
        opacity: 0.8,
        zIndex: 3,
      },
    ],
  },
  monochrome: {
    backgroundColor: '#1a1a1a',
    shapes: [
      {
        id: 'mono-1',
        width: 80,
        height: 25,
        x: 5,
        y: 15,
        gradient: 'radial-gradient(ellipse, #636e72 0%, #2d3436 50%, #ddd 100%)',
        blur: 15,
        opacity: 0.4,
        zIndex: 1,
      },
      {
        id: 'mono-2',
        width: 70,
        height: 20,
        x: 45,
        y: 35,
        gradient: 'radial-gradient(ellipse, #b2bec3 0%, #636e72 50%, #2d3436 100%)',
        blur: 19,
        opacity: 0.6,
        zIndex: 2,
      },
      {
        id: 'mono-3',
        width: 75,
        height: 28,
        x: 15,
        y: 65,
        gradient: 'radial-gradient(ellipse, #ddd 0%, #74b9ff 50%, #636e72 100%)',
        blur: 18,
        opacity: 0.3,
        zIndex: 3,
      },
    ],
  },
  minimal: {
    backgroundColor: '#f8f9fa',
    shapes: [
      {
        id: 'minimal-1',
        width: 90,
        height: 25,
        x: -20,
        y: 25,
        gradient: 'radial-gradient(ellipse, rgba(116, 185, 255, 0.6) 0%, rgba(166, 206, 255, 0.4) 50%, rgba(200, 220, 255, 0.2) 100%)',
        blur: 20,
        opacity: 0.9,
        zIndex: 1,
      },
      {
        id: 'minimal-2',
        width: 75,
        height: 30,
        x: 50,
        y: -5,
        gradient: 'radial-gradient(ellipse, rgba(99, 110, 114, 0.4) 0%, rgba(178, 190, 195, 0.3) 50%, rgba(220, 221, 225, 0.2) 100%)',
        blur: 18,
        opacity: 0.8,
        zIndex: 2,
      },
      {
        id: 'minimal-3',
        width: 65,
        height: 20,
        x: 20,
        y: 70,
        gradient: 'radial-gradient(ellipse, rgba(74, 144, 226, 0.5) 0%, rgba(144, 224, 239, 0.3) 50%, rgba(237, 242, 247, 0.2) 100%)',
        blur: 15,
        opacity: 0.7,
        zIndex: 3,
      },
    ],
  },
  spring: {
    backgroundColor: '#f0f8f0',
    shapes: [
      {
        id: 'spring-1',
        width: 85,
        height: 30,
        x: -15,
        y: 20,
        gradient: 'radial-gradient(ellipse, rgba(144, 238, 144, 0.7) 0%, rgba(152, 251, 152, 0.5) 50%, rgba(173, 255, 173, 0.3) 100%)',
        blur: 18,
        opacity: 0.8,
        zIndex: 1,
      },
      {
        id: 'spring-2',
        width: 70,
        height: 25,
        x: 50,
        y: -5,
        gradient: 'radial-gradient(ellipse, rgba(255, 182, 193, 0.6) 0%, rgba(255, 228, 196, 0.4) 50%, rgba(240, 255, 240, 0.2) 100%)',
        blur: 16,
        opacity: 0.7,
        zIndex: 2,
      },
      {
        id: 'spring-3',
        width: 75,
        height: 28,
        x: 20,
        y: 65,
        gradient: 'radial-gradient(ellipse, rgba(255, 255, 224, 0.8) 0%, rgba(144, 238, 144, 0.6) 30%, rgba(173, 216, 230, 0.4) 100%)',
        blur: 20,
        opacity: 0.6,
        zIndex: 3,
      },
    ],
  },
  sky: {
    backgroundColor: '#f0f8ff',
    shapes: [
      {
        id: 'sky-1',
        width: 95,
        height: 35,
        x: -25,
        y: 15,
        gradient: 'radial-gradient(ellipse, rgba(135, 206, 235, 0.6) 0%, rgba(173, 216, 230, 0.4) 50%, rgba(230, 248, 255, 0.2) 100%)',
        blur: 22,
        opacity: 0.8,
        zIndex: 1,
      },
      {
        id: 'sky-2',
        width: 80,
        height: 30,
        x: 45,
        y: 35,
        gradient: 'radial-gradient(ellipse, rgba(255, 255, 255, 0.8) 0%, rgba(240, 248, 255, 0.5) 50%, rgba(135, 206, 235, 0.3) 100%)',
        blur: 19,
        opacity: 0.9,
        zIndex: 2,
      },
      {
        id: 'sky-3',
        width: 70,
        height: 25,
        x: 15,
        y: 70,
        gradient: 'radial-gradient(ellipse, rgba(176, 224, 230, 0.7) 0%, rgba(173, 216, 230, 0.5) 40%, rgba(240, 248, 255, 0.3) 100%)',
        blur: 17,
        opacity: 0.7,
        zIndex: 3,
      },
    ],
  },
  cream: {
    backgroundColor: '#fefefe',
    shapes: [
      {
        id: 'cream-1',
        width: 85,
        height: 30,
        x: -10,
        y: 25,
        gradient: 'radial-gradient(ellipse, rgba(255, 228, 196, 0.7) 0%, rgba(255, 239, 213, 0.5) 50%, rgba(255, 248, 220, 0.3) 100%)',
        blur: 18,
        opacity: 0.8,
        zIndex: 1,
      },
      {
        id: 'cream-2',
        width: 75,
        height: 25,
        x: 50,
        y: 10,
        gradient: 'radial-gradient(ellipse, rgba(245, 222, 179, 0.6) 0%, rgba(255, 239, 213, 0.4) 50%, rgba(255, 250, 240, 0.2) 100%)',
        blur: 16,
        opacity: 0.7,
        zIndex: 2,
      },
      {
        id: 'cream-3',
        width: 80,
        height: 28,
        x: 20,
        y: 60,
        gradient: 'radial-gradient(ellipse, rgba(255, 218, 185, 0.8) 0%, rgba(255, 228, 196, 0.6) 30%, rgba(255, 245, 238, 0.4) 100%)',
        blur: 19,
        opacity: 0.6,
        zIndex: 3,
      },
    ],
  },
  dawn: {
    backgroundColor: '#fef9f3',
    shapes: [
      {
        id: 'dawn-1',
        width: 90,
        height: 32,
        x: -20,
        y: 20,
        gradient: 'radial-gradient(ellipse, rgba(255, 182, 193, 0.6) 0%, rgba(255, 218, 185, 0.4) 50%, rgba(255, 239, 213, 0.2) 100%)',
        blur: 20,
        opacity: 0.8,
        zIndex: 1,
      },
      {
        id: 'dawn-2',
        width: 75,
        height: 28,
        x: 50,
        y: 5,
        gradient: 'radial-gradient(ellipse, rgba(255, 160, 122, 0.7) 0%, rgba(255, 192, 203, 0.5) 40%, rgba(255, 228, 225, 0.3) 100%)',
        blur: 17,
        opacity: 0.7,
        zIndex: 2,
      },
      {
        id: 'dawn-3',
        width: 80,
        height: 25,
        x: 15,
        y: 65,
        gradient: 'radial-gradient(ellipse, rgba(255, 239, 213, 0.8) 0%, rgba(255, 228, 196, 0.6) 50%, rgba(255, 245, 238, 0.4) 100%)',
        blur: 18,
        opacity: 0.6,
        zIndex: 3,
      },
    ],
  },
  pearl: {
    backgroundColor: '#f8f8ff',
    shapes: [
      {
        id: 'pearl-1',
        width: 85,
        height: 30,
        x: -15,
        y: 25,
        gradient: 'radial-gradient(ellipse, rgba(230, 230, 250, 0.8) 0%, rgba(240, 248, 255, 0.6) 50%, rgba(255, 250, 250, 0.4) 100%)',
        blur: 19,
        opacity: 0.9,
        zIndex: 1,
      },
      {
        id: 'pearl-2',
        width: 70,
        height: 25,
        x: 45,
        y: 15,
        gradient: 'radial-gradient(ellipse, rgba(248, 248, 255, 0.7) 0%, rgba(230, 230, 250, 0.5) 40%, rgba(255, 255, 255, 0.3) 100%)',
        blur: 16,
        opacity: 0.8,
        zIndex: 2,
      },
      {
        id: 'pearl-3',
        width: 75,
        height: 28,
        x: 20,
        y: 65,
        gradient: 'radial-gradient(ellipse, rgba(221, 160, 221, 0.4) 0%, rgba(230, 230, 250, 0.6) 50%, rgba(240, 248, 255, 0.3) 100%)',
        blur: 18,
        opacity: 0.7,
        zIndex: 3,
      },
    ],
  },
  blush: {
    backgroundColor: '#fff5f8',
    shapes: [
      {
        id: 'blush-1',
        width: 85,
        height: 30,
        x: -10,
        y: 20,
        gradient: 'radial-gradient(ellipse, rgba(255, 182, 193, 0.6) 0%, rgba(255, 192, 203, 0.4) 50%, rgba(255, 228, 225, 0.2) 100%)',
        blur: 18,
        opacity: 0.8,
        zIndex: 1,
      },
      {
        id: 'blush-2',
        width: 75,
        height: 25,
        x: 50,
        y: 10,
        gradient: 'radial-gradient(ellipse, rgba(255, 160, 200, 0.7) 0%, rgba(255, 182, 193, 0.5) 40%, rgba(255, 240, 245, 0.3) 100%)',
        blur: 16,
        opacity: 0.7,
        zIndex: 2,
      },
      {
        id: 'blush-3',
        width: 80,
        height: 28,
        x: 25,
        y: 65,
        gradient: 'radial-gradient(ellipse, rgba(255, 228, 225, 0.8) 0%, rgba(255, 192, 203, 0.6) 30%, rgba(255, 250, 250, 0.4) 100%)',
        blur: 19,
        opacity: 0.6,
        zIndex: 3,
      },
    ],
  },
}; 